import styled from 'styled-components';
import MaskRoundedXl from '@public/mask__rounded--xl.png';
import { breakpoints } from '@theme/breakpoints';

export const StyledFeatureInfoCardsSection = styled.section`
  margin: 0 auto;
  text-align: center;

  .wrapper {
    display: flex;
    flex-direction: row;
    gap: 8rem;
    margin-bottom: 6rem;

    @media ${breakpoints.tabletMax} {
      gap: 0;
    }

    .form-container {
      width: 50%;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: center;
      align-content: flex-start;

      .submittedText {
        font-size: var(--fonts-sizing-h3Large);
        font-family: var(--fonts-family-secondary);
        line-height: 1.2;
        font-weight: normal;
      }
      @media ${breakpoints.tabletMax} {
        width: 100%;
      }
    }

    .image-container {
      width: 50%;

      .image-shape {
        margin: 0 auto;
        @media ${breakpoints.tablet} {
          max-width: 600px;
        }
        img {
          object-fit: contain;
          mask-size: contain;
          mask-image: url(${MaskRoundedXl.src});
          mask-repeat: no-repeat;
          mask-position: center;
        }
      }
      @media ${breakpoints.tabletMax} {
        width: 0;
      }
    }
  }
`;
